<template lang="pug">
.app.d-flex.flex-column
  .container.grid-md.p-relative
    .header
      header-component
    .app-content.full-height
      transition(name="slide-fade-y", mode="out-in")
        router-view
  .footer
    footer-component
</template>

<script>
import FooterComponent from "@/components/Footer";
import HeaderComponent from "@/components/Header";

export default {
  components: { FooterComponent, HeaderComponent },
};
</script>

<style lang="stylus" scoped>
.app {
  height: 100vh;

  .container {
    flex: 1;
  }
}

.btn.btn-lg {
  i {
    font-size: 2.5rem;
  }
}

.header {
  top: 0;
  padding: 20px 0;
}

a {
  text-decoration: none;
  box-shadow: none;
}

.app-content {
  flex: 1;
  overflow-y: hidden;
}
</style>
